import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import { isFunction } from '../../utilities/check';
import { Scroller } from './List';
import ListHeader from './ListHeader';

const MobileListView = ({
  columns,
  showUrlProvider,
  idProvider,
  onViewClick,
  getList,
  data,
  history,
  location,
  highlightedProvider,
  highlightedRowStyles,
  highlightedRowStyleProvider,
  tableKey,
  useCSVExport,
  MobileItemComponent,
}) => {
  const classes = useStyles();

  const handleViewClick = data => () => {
    if (isFunction(onViewClick)) {
      onViewClick(data);
    }
  };

  const list = getList(data);
  return (
    <Fragment>
      <ListHeader
        showColumnSelection={false}
        showCSVExport={useCSVExport}
        selectedColumns={[]}
        setSelectedColumns={() => {}}
        columns={columns}
        columnOptions={[]}
        tableKey={tableKey}
        list={list}
        data={data}
      />
      <Box className={classes.listItemsContainer}>
        {list.map((item, i) => (
          <Scroller key={`${idProvider(item)}-${i}`} collection={location.pathname} id={idProvider(item)}>
            <MobileItemComponent
              history={history}
              location={location}
              columns={columns}
              item={item}
              context={{ data }}
              index={i}
              showUrlProvider={showUrlProvider}
              idProvider={idProvider}
              onClick={handleViewClick(item)}
              highlighted={((highlightedProvider ? highlightedProvider(item) : false) && 'true') || undefined}
              highlightedRowStyles={
                highlightedRowStyleProvider ? highlightedRowStyleProvider(item) : highlightedRowStyles
              }
            />
          </Scroller>
        ))}
      </Box>
    </Fragment>
  );
};

const useStyles = makeStyles(theme => ({
  listItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export default MobileListView;
